/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const PaginatedAccountListList = zod.strictObject({
    count: zod.number().optional(),
    has_next: zod.boolean().optional(),
    has_previous: zod.boolean().optional(),
    limit: zod.number().optional(),
    page: zod.number().optional().describe('The current page number'),
    pages: zod.number().optional().describe('The total number of pages'),
    results: zod
        .array(
            zod.strictObject({
                id: zod.number(),
                name: zod.string().min(1),
                created_at: zod.iso.datetime({ offset: true }),
                updated_at: zod.iso.datetime({ offset: true }),
            }),
        )
        .optional(),
});

export type PaginatedAccountListList = zod.input<
    typeof PaginatedAccountListList
>;
export type PaginatedAccountListListOutput = zod.output<
    typeof PaginatedAccountListList
>;
